import { Pipe, PipeTransform } from '@angular/core';

import { calculateAvailableModules } from '../../enclosure/helpers/enclosure.helper';

@Pipe({
    name: 'getAvailableModulesText',
    standalone: false
})
export class GetAvailableModulesTextPipe implements PipeTransform {

  transform(occupiedModules: number, element: HTMLDivElement): string {
    return element?.title + ' (' + calculateAvailableModules(occupiedModules) + '%)';
  }

}


